// Modules
import cn from "classnames";
import Autosuggest from "react-autosuggest";

// Hooks
import useSearchBar from "hooks/searchPage/useSearchBar";

interface SearchBarProps {
	mobileSearch: boolean;
}
const SearchBar = ({ mobileSearch }: SearchBarProps) => {
	const {
		suggestions,
		value,
		getSuggestionValue,
		onSuggestionsFetchRequested,
		onSuggestionsClearRequested,
		onChangeValue,
		onKeyPress,
		clearValue,
		shouldRenderSuggestions,
		onSuggestionSelected,
		renderSuggestion,
		handleSubmitSearch
	} = useSearchBar();

	return (
		<div className="wk-search-form-container">
			<div className={cn("wk-search-container", { "wk-visible": mobileSearch })}>
				<Autosuggest
					suggestions={suggestions}
					onSuggestionsFetchRequested={onSuggestionsFetchRequested}
					onSuggestionsClearRequested={onSuggestionsClearRequested}
					getSuggestionValue={getSuggestionValue}
					renderSuggestion={renderSuggestion}
					shouldRenderSuggestions={shouldRenderSuggestions}
					onSuggestionSelected={onSuggestionSelected}
					inputProps={{
						placeholder: "Cerca per parola chiave, argomento ecc",
						value,
						onChange: onChangeValue,
						onKeyPress
					}}
				/>
			</div>
			<button className="wk-search-submit" style={{ position: "static" }} type="submit" aria-label="submit" onClick={handleSubmitSearch}>
				<span className="wk-icon-search" />
			</button>
			<button
				className={cn("wk-close-search-bar", {
					"wk-visible": value.length > 0
				})}
				onClick={clearValue}
				type="submit"
				aria-label="close"
			>
				<span className="wk-icon-close-circle" />
			</button>
		</div>
	);
};

export default SearchBar;
